import "core-js/modules/es6.regexp.replace";
import { __extends } from "tslib";
import { networkErrors } from '@/constants';
import routerInstance from '@/setup/router/router';

var CustomNetworkError =
/** @class */
function (_super) {
  __extends(CustomNetworkError, _super);

  function CustomNetworkError(name, response) {
    var _this = _super.call(this, name) || this;

    _this.response = response;
    return _this;
  }

  return CustomNetworkError;
}(Error); // tslint:disable-next-line:max-classes-per-file


var NetworkError =
/** @class */
function (_super) {
  __extends(NetworkError, _super);

  function NetworkError(response) {
    return _super.call(this, networkErrors.network, response) || this;
  }

  return NetworkError;
}(CustomNetworkError);

export { NetworkError }; // tslint:disable-next-line:max-classes-per-file

var ServerError =
/** @class */
function (_super) {
  __extends(ServerError, _super);

  function ServerError(response) {
    return _super.call(this, networkErrors.server, response) || this;
  }

  return ServerError;
}(CustomNetworkError);

export { ServerError }; // tslint:disable-next-line:max-classes-per-file

var AuthorizationError =
/** @class */
function (_super) {
  __extends(AuthorizationError, _super);

  function AuthorizationError(response) {
    return _super.call(this, networkErrors.perms, response) || this;
  }

  return AuthorizationError;
}(CustomNetworkError);

export { AuthorizationError }; // tslint:disable-next-line:max-classes-per-file

var ValidationError =
/** @class */
function (_super) {
  __extends(ValidationError, _super);

  function ValidationError(response) {
    return _super.call(this, networkErrors.validation, response) || this;
  }

  return ValidationError;
}(CustomNetworkError);

export { ValidationError }; // tslint:disable-next-line:max-classes-per-file

var AuthenticationError =
/** @class */
function (_super) {
  __extends(AuthenticationError, _super);

  function AuthenticationError(response) {
    var _this = _super.call(this, networkErrors.auth, response) || this;

    routerInstance.replace({
      name: 'login',
      params: {
        e: btoa(JSON.stringify(response))
      }
    });
    return _this;
  }

  return AuthenticationError;
}(CustomNetworkError);

export { AuthenticationError }; // tslint:disable-next-line:max-classes-per-file

var NotFoundError =
/** @class */
function (_super) {
  __extends(NotFoundError, _super);

  function NotFoundError(response) {
    var _this = _super.call(this, networkErrors.notFound, response) || this;

    routerInstance.replace({
      name: 'subdomain-not-found'
    });
    return _this;
  }

  return NotFoundError;
}(CustomNetworkError);

export { NotFoundError }; // tslint:disable-next-line:max-classes-per-file

var UnprocessableEntityError =
/** @class */
function (_super) {
  __extends(UnprocessableEntityError, _super);

  function UnprocessableEntityError(response) {
    var _this = _super.call(this, networkErrors.unprocessableEntity, response) || this;

    routerInstance.replace({
      name: 'local-disabled'
    });
    return _this;
  }

  return UnprocessableEntityError;
}(CustomNetworkError);

export { UnprocessableEntityError };